import screens from '@constants/theme/screens.config';
import styled from '@emotion/styled';

export const SadaShowMobile = styled.div`
  display: none;
  ${screens.mobile} {
    display: block;
  }
`;
